import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Drawer,
  MenuItem,
  Typography,
} from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMemo, useState } from "react";
import { businessesGet, businessDelete, businessEdit } from "../../api/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { Form, Formik, Field, FastField } from "formik";
import * as Yup from "yup";
import { CheckboxWithLabel, Select, TextField } from "formik-mui";
import React from "react";
import phone from "phone";
import { useSnackbar } from "../../store/store";
import MuiPhoneNumber from "material-ui-phone-number-2";
import { useCallback } from "react";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import ct from "countries-and-timezones";
import { useProfile } from "../../api/hooks";
import { useMedia } from "react-use";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

export const Businesses = ({ selectedBusiness }: { selectedBusiness: any }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const { profile, refetchProfile } = useProfile();
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selected, setSelected] = useState<any | null>(null);
  const snackbar = useSnackbar();
  const queryClient = useQueryClient();
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === "SUPER_ADMIN") ?? false;
  const countries = ct.getAllCountries();

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfBusinessesResponse } = useQuery(
    'getUserAdminOfBusinesses',
    getUserAdminOfBusinesses,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfBusinesses = getUserAdminOfBusinessesResponse!.data;

  const [selectedBusinessId, setSelectedBusinessId] = useState<number>(
    userAdminOfBusinesses[0]?.id,
  );
  */

  //console.log('selected1', selected);

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery(["businessesGet"], businessesGet(), {
    enabled: true,
    refetchOnWindowFocus: false,
  });

  const data: any = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation("businessEdit", businessEdit, {
    onError: (err: any) => {
      alert("Error", err.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries(["profile", "businesses"]);
      refetchProfile();
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }

    const columnDefs: ColDef[] = [
      {
        field: "name",
        headerName: "Name",
        sortable: true,
        initialSort: "asc",
        flex: 1,
        minWidth: 160,
        filter: true,
      },
      {
        field: "enabled",
        headerName: "Enabled",
        sortable: true,
        flex: 1,
        minWidth: 70,
        cellRenderer: ({ data }) => {
          return !!data.enabled ? <DoneIcon /> : <CloseIcon />;
        },
      },
      {
        field: "type",
        headerName: "Type",
        sortable: true,
        flex: 1,
        minWidth: 94,
      },
      {
        field: "createdAt",
        headerName: "Created at",
        sortable: true,
        flex: 1,
        minWidth: 160,
        valueFormatter: ({ data }) => {
          return moment(data.createdAt).format("YYYY-MM-DD HH:mm");
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  const handlePhoneChange = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: "phone", value } });
    },
    []
  );

  return (
    <>
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deletion confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`This will delete the business with all of its connected data. The business will not be deleted if it has a pending transaction. Are you sure you want to delete this business?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await businessDelete(selected.id)();
                setConfirmOpen(false);
                queryClient.invalidateQueries([
                  "businesses",
                  "getUserAdminOfBusinesses",
                  "profile",
                ]);
                refetch();
                if (response) setRightDrawerOpen(false);
              } catch (error: any) {
                setConfirmOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: "100vw", sm: "600px" } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "1.3em", fontWeight: 500, m: "16px 24px" }}
            >
              {!!selected ? "Edit business" : "Add business"}
            </Typography>
            <Divider />
            <Box sx={{ padding: "24px" }}>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the business.'}
              */}
              <Formik
                validateOnMount
                initialValues={
                  selected || {
                    name: "",
                    legalName: "",
                    email: "",
                    phone: "",
                    country: "",
                    state: "",
                    city: "",
                    streetAddress: "",
                    postalCode: "",
                    taxId: "",
                    taxBranchOfficeId: "",
                    taxSerialNumber: "",
                    type: "",
                    enabled: false,
                    primaryColor: "#4285F4",
                    secondaryColor: "#4285F4",
                  }
                }
                validationSchema={Yup.object().shape({
                  name: Yup.string()
                    .min(2, "Too short")
                    .max(50, "Too long")
                    .required("Required"),
                  legalName: Yup.string()
                    .min(2, "Too short")
                    .max(50, "Too long"),
                  email: Yup.string()
                    .email("Invalid email")
                    .required("Required"),
                  phone: Yup.string()
                    .test("phone", "Invalid phone number", (value) => {
                      console.log("phone", value);

                      if (!value) return true;
                      return phone(value).isValid;
                    })
                    .required("Required"),
                  country: Yup.string().required("Required"),
                })}
                onSubmit={async ({ ...values }, { setSubmitting }) => {
                  console.log(values);

                  try {
                    const response = await mutateAsync({ values });

                    /*
                    if (
                      !selected &&
                      !values?.enabled &&
                      response?.status === 201
                    )
                      snackbar.open({
                        type: 'success',
                        message:
                          'Thank you for your interest. We will contact you.',
                      });
                      */
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  refetch();
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      position: "relative",
                    }}
                  >
                    <FastField
                      component={TextField}
                      label="Name"
                      name="name"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Legal name"
                      name="legalName"
                      size="small"
                    />
                    <Box className="small-formik-select-fix">
                      <FastField
                        component={Select}
                        label="Country"
                        id="country"
                        name="country"
                        size="small"
                        required
                      >
                        {!!countries &&
                          Object.keys(countries).map((c) => (
                            <MenuItem
                              key={countries[c]?.id}
                              value={countries[c]?.name}
                            >
                              {countries[c]?.name}
                            </MenuItem>
                          ))}
                      </FastField>
                    </Box>
                    <FastField
                      component={TextField}
                      label="State"
                      name="state"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="City"
                      name="city"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Street address"
                      name="streetAddress"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Postal code"
                      name="postalCode"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Tax ID"
                      name="taxId"
                      type="email"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Tax Branch Office ID"
                      name="taxBranchOfficeId"
                      type="email"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Tax Device Serial Number"
                      name="taxSerialNumber"
                      type="email"
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Contact email"
                      name="email"
                      type="email"
                      size="small"
                    />
                    <MuiPhoneNumber
                      required
                      defaultCountry={"rw"}
                      name="phone"
                      label="Contact phone"
                      variant="outlined"
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handlePhoneChange(handleChange)}
                      error={touched.phone && !!errors.phone}
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      //@ts-ignore
                      helperText={(touched.phone && errors.phone) || ""}
                      className="MuiPhoneNumber"
                      InputLabelProps={{ required: false }}
                      size="small"
                    />
                    <FastField
                      component={TextField}
                      label="Primary color"
                      name="primaryColor"
                      size="small"
                      helperText="Hex color code (e.g. #ff0000)"
                    />
                    <FastField
                      component={TextField}
                      label="Secondary color"
                      name="secondaryColor"
                      size="small"
                      helperText="Hex color code (e.g. #ff0000)"
                    />
                    {isSuperAdmin && (
                      <Field
                        component={CheckboxWithLabel}
                        type="checkbox"
                        name="enabled"
                        Label={{ label: "Enabled" }}
                        size="small"
                      />
                    )}
                    <Box
                      sx={{
                        textAlign: "right",
                        margin: "8px 0 0",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        onClick={() => {
                          setRightDrawerOpen(false);
                        }}
                        sx={{ padding: "6px 8px" }}
                      >
                        Cancel
                      </Button>
                      <Box sx={{ flex: "1 1 auto" }} />
                      {selected && (
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => {
                            setConfirmOpen(true);
                          }}
                          sx={{ padding: "6px 8px" }}
                        >
                          Delete
                        </Button>
                      )}
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={isSubmitting || !isValid}
                        onClick={submitForm}
                        sx={{ padding: "6px 24px" }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      {/*}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? An owner of an business cannot be deleted. This cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                console.log(selected);
                
                const response = await businessDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            alignItems: "center",
            gap: 1,
            height: "56px",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: "1.25rem",
            }}
          >
            Businesses
          </Typography>

          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
        </Box>
        <Card
          className="ag-theme-material"
          sx={{
            borderRadius: 0,
            margin: "0 -16px -16px",
            display: "flex",
            overflow: "hidden",
            flexGrow: 1,
            height: "100%",
            boxShadow: "none !important",
          }}
        >
          {isFetching && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box sx={{ display: isFetching ? "none !important" : "block" }}>
            <AgGridReact
              className="ag-pointer-row"
              rowData={rowData}
              pagination={true}
              floatingFiltersHeight={50}
              paginationAutoPageSize={true}
              columnDefs={columnDefs}
              onRowClicked={({ data }) => {
                //navigate(`/admin/business/${data.id}`);

                setSelected(data);
                setRightDrawerOpen(true);
              }}
            ></AgGridReact>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default Businesses;
